/* eslint-disable ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import titleize from 'ember-cli-string-helpers/utils/titleize';

export default class DeleteDialog extends Component {
  @service
  router;

  @service
  toaster;

  entityType = 'entity';
  entity = null;
  @tracked
  errorMessage = '';
  // deleting guards against double-clicking "Yes, delete it", which would
  // fire destroyRecord() twice -- the second call crashes with "Attempted to
  // handle event deleteRecord ... while in state root.empty" once the first
  // has already deleted the record.
  @tracked
  deleting = false;

  // onClose is the action to be performed when closing the dialog.
  onClose() {}

  @action
  closeDialog() {
    this.onClose();
  }

  @action
  doDeleteEntity() {
    if (this.deleting || !this.entity) {
      return;
    }
    this.errorMessage = '';
    this.deleting = true;

    let entityType = this.entity.get('constructor.modelName');
    let isTopic = entityType === 'goals/subject' && this.entity.isTopic;
    this.entity
      .destroyRecord()
      .then(() => {
        this.onClose();
        this.toaster.success(
          `${titleize(this.entityType)} deleted successfully.`,
        );

        if (entityType === 'goals/subject') {
          // The entire subject was deleted; navigate back to the Goals or
          // Topics admin page.
          if (isTopic) {
            this.router.transitionTo('topics');
          } else {
            this.router.transitionTo('goals');
          }
        }
      })
      .catch((err) => {
        this.entity.rollbackAttributes();
        // err isn't always a JSON:API AdapterError with an errors[] array --
        // e.g. an internal Ember Data state error (as happens if this ever
        // fires twice) is a plain Error with no `errors` property.
        let detail = !isEmpty(err && err.errors) && err.errors[0].detail;
        this.errorMessage = detail || 'Failed to delete.';
      })
      .finally(() => {
        if (this.isDestroying || this.isDestroyed) {
          return;
        }
        this.deleting = false;
      });
  }
}
